/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { TabSectionHeader } from '../OverviewTab/TabSectionHeader';
import { SpecialInstructionsCard } from './SpecialInstructions';
import { NotesLog } from './NotesLog/NotesLog';

const styles = StyleSheet.create({
  wrapper: {
    padding: '0 40px',
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 50,
    maxWidth: 1000,
  },
});

export namespace NotesTab {
  export interface Props {
    roomId: string;
    notesLoading: boolean;
  }
}

export const NotesTab: React.FC<NotesTab.Props> = ({ roomId, notesLoading }) => {
  return (
    <div data-it={'RoomNotesTab'} className={css(styles.wrapper)}>
      <TabSectionHeader>Lender Instructions</TabSectionHeader>
      <SpecialInstructionsCard />
      <NotesLog roomId={roomId} notesLoading={notesLoading} />
    </div>
  );
};
